<template>
  <div v-if="items.length" class="page-home-featured">
    <carousel
      ref="carousel"
      :perPage="1"
      autoplay
      autoplayHoverPause
      :autoplayTimeout="carouselTimeout"
      loop
    >
      <slide
        v-for="(
          { img, title, date, to, categoryTitle, categoryTo }, i
        ) in items"
        :key="i"
      >
        <v-card
          :to="to"
          :style="{ '--img': `url('${img}')` }"
          class="page-home-featured-item"
          flat
          tile
        >
          <div
            class="page-home-featured-item-inner d-flex flex-column justify-end"
          >
            <div>
              <v-btn
                class="
                  text-body-sm-1 text-body-2 text-uppercase
                  font-weight-bold
                  mb-4
                  rounded-pill
                "
                color="accent"
                :to="categoryTo"
                :x-small="xs"
                depressed
              >
                <span class="montserrat">
                  {{ categoryTitle }}
                </span>
              </v-btn>
              <div
                v-html="title"
                class="
                  page-home-featured-item-title
                  font-weight-bold
                  white--text
                  mb-1 mb-sm-4
                "
              ></div>
              <div class="white--text text-body-2">
                <v-icon class="mr-2 mb-1" color="white" small>
                  far fa-calendar
                </v-icon>
                <span>{{ formatDate(date) }}</span>
              </div>
            </div>
          </div>
        </v-card>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { formatToURL } from "@/components/utils.js";
import { carouselTimeout, carouselFeaturedCount } from "@/config.js";

const _config = {
  mod: "articles",
};

export default {
  data: () => ({
    items: [],
    carouselTimeout,
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    formatDate(str) {
      const dateTimeFormat = new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });

      return dateTimeFormat.format(new Date(str.replace(/\s/, "T")));
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({ params: { itemsPerPage: carouselFeaturedCount, highlight: 1 } })
      .then(
        (data) =>
          (this.items = data.map(({ id, title, date, img, category }) => {
            const categoryTo = `/noticias/${formatToURL(category.title)}`;

            return {
              title,
              date,
              img: this.files + img + "?resize=1&w=656",
              categoryTitle: category.title,
              categoryTo,
              to: `${categoryTo}/${formatToURL(title)}-${id}`,
            };
          }))
      );
  },
};
</script>

<style>
.page-home-featured {
  position: relative;
}
.page-home-featured .owl-nav {
  display: none;
}

.page-home-featured-item {
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0) 75.22%
    ),
    var(--img), #b7b7b7;

  aspect-ratio: 67/40;
  background-size: cover;
  background-position: center;
}
.page-home-featured-item-inner {
  padding: 29px 24px 51px;
  height: 100%;
  width: 100%;
}

.page-home-featured .VueCarousel-pagination {
  position: absolute;
  bottom: 16px;
  left: 54px;
  right: 54px;
  z-index: 100;
  display: flex;
  justify-content: center;
  width: calc(100% - 108px) !important;
}

.page-home-featured .VueCarousel-dot-container {
  margin-top: 0 !important;
}

.page-home-featured .VueCarousel-dot {
  background-color: transparent !important;
  margin-left: 8px !important;
  margin-right: 8px !important;
  margin-top: 0px !important;
  padding: 0px !important;
  height: 10px !important;
  width: 10px !important;
  border: 1px solid white !important;
  outline: none !important;
}
.page-home-featured .VueCarousel-dot.VueCarousel-dot--active {
  background-color: white !important;
  border: 1px solid white !important;
}
.page-home-featured-item-title {
  font-size: 28px;
  line-height: 28.8px;
}

@media screen and (max-width: 960px) {
  .page-home-featured-item-title {
    font-size: 16px;
    line-height: 19px;
  }
  .page-home-featured-item-inner {
    padding: 16px 12px;
  }
}

@media screen and (max-width: 600px) {
  .page-home-featured .VueCarousel,
  .page-home-featured-item {
    max-width: calc(100vw - 24px) !important;
  }

  .page-home-featured .VueCarousel-pagination {
    top: 12px;
    bottom: initial;
  }

  .page-home-featured .VueCarousel-dot {
    background-color: white !important;
    border: none !important;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
  }

  .page-home-featured .VueCarousel-dot.VueCarousel-dot--active {
    background-color: var(--v-primary-base) !important;
    border: none !important;
  }
}

.page-home-featured-item,
.page-home-featured-item .page-home-featured-item-title {
  transition: all 0.1s linear;
}

.page-home-featured-item:hover {
  opacity: 0.9;
}

.page-home-featured-item:hover .page-home-featured-item-title {
  color: #dbdbdb !important;
}
</style>
